// These characters are outside ASCII, so the SMS composer treats the message as Unicode.
const UNICODE_PUNCTUATION = {
  "\u2013": "-", // –
  "\u2014": "-", // —
  "\u2212": "-", // −
  "\u00AF": "-", // ¯
  "\u203E": "-", // ‾
  "\u00B4": "'" // ´
};

const UNICODE_PUNCTUATION_PATTERN = /[\u2013\u2014\u2212\u00AF\u203E\u00B4]/g;

const TEXT_INPUT_TYPES = new Set(["text", "search", "url", "tel", "email"]);

export function replaceUnicodePunctuation(value) {
  if (typeof value !== "string") return value;
  return value.replace(UNICODE_PUNCTUATION_PATTERN, character => UNICODE_PUNCTUATION[character]);
}

function isTextControl(element) {
  if (!element || element.disabled || element.readOnly) return false;
  if (element.tagName === "TEXTAREA") return true;
  if (element.tagName !== "INPUT") return false;
  return TEXT_INPUT_TYPES.has((element.type || "text").toLowerCase());
}

function handleTypedUnicodeInput(event) {
  const element = event.target;
  if (!isTextControl(element)) return;

  const currentValue = element.value;
  const nextValue = replaceUnicodePunctuation(currentValue);
  if (nextValue === currentValue) return;

  const selectionStart = element.selectionStart;
  const selectionEnd = element.selectionEnd;
  // React records the field value when it is assigned. Put the previous value back
  // so the message box still receives this paste and the SMS count can update.
  const tracker = element._valueTracker;
  const trackedValue = tracker ? tracker.getValue() : undefined;
  element.value = nextValue;
  if (tracker) {
    tracker.setValue(trackedValue);
  }
  if (typeof element.setSelectionRange === "function" && typeof selectionStart === "number" && typeof selectionEnd === "number") {
    element.setSelectionRange(selectionStart, selectionEnd);
  }
}

let attached = false;

export function attachUnicodePunctuationReplacer() {
  if (attached || typeof document === "undefined") return;
  attached = true;
  document.addEventListener("input", handleTypedUnicodeInput, true);
}
